export default __webpack_public_path__ + "static/media/youtube.31258503.svg";